module.exports = __webpack_public_path__ + "static/top-7c1a5cc40620fd3bb64c51adfe3381ac.jpeg";